<!--
 * @Description: 同意授权书组件
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2026-05-21
 * @LastEditors: zhangle
 * @LastEditTime: 2026-05-21
-->
<template>
    <div class="tsa-authorizationLetter" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="title-top">
                <h4>同意授权书</h4>
                <img @click="close" src="/static/img/icon/close.png" alt="">
            </div>
            <div class="scroll">
                <div class="text-container">
                    <p>您的企业正由【{{ operatorName }}】办理数字证书开通。</p>
                    <p>该操作具有法律效力。一旦确认，经办人提交的资料将视为贵司真实意愿，产生的数字证书具备法律效力。</p>
                </div>
                <div class="checked">
                    <img @click="checkedFun" :src="checked ? require('./images/checkbox_true.png') : require('./images/checkbox_false.png')" alt="">
                    <p @click="checkedFun">已阅读并同意<span @click.stop="preview">《机构委托授权书》</span></p>
                </div>
            </div>
            <div class="bottom">
                <div class="btn" @click="close">
                    <p>取消</p>
                </div>
                <div class="btn confirm" @click="confirm">
                    <p>同意并授权</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { signAuthorizationViewApi } from '@/api/common'
import { setBodyOverflow } from '@/js/utils'
export default {
    name: 'TsaAuthorizationLetter',
    data () {
        return {
            show: false,
            checked: false,
            contractId: '',
            signSessionId: '',
            // 经办人姓名
            operatorName: '',
            // 经办人身份证号
            operatorIdCard: '',
            // 经办人手机号
            operatorPhone: '',
            // 企业名称
            enterpriseName: '',
            // 统一社会信用代码
            enterpriseCreditCode: '',
            // 法定代表人姓名
            legalRepName: '',
            pdfUrl: '',
            ossKey: ''
        }
    },
    watch: {
        show (val) {
            setBodyOverflow(val)
            if (!val) {
                this.checked = false
                this.contractId = ''
                this.signSessionId = ''
                this.operatorName = ''
                this.operatorIdCard = ''
                this.operatorPhone = ''
                this.enterpriseName = ''
                this.enterpriseCreditCode = ''
                this.legalRepName = ''
                this.pdfUrl = ''
                this.ossKey = ''
                
            }
        }
    },
    methods: {
        init () {
            this.$TsaLoading.show()
            signAuthorizationViewApi({
                operatorName: this.operatorName,
                operatorIdCard: this.operatorIdCard,
                operatorPhone: this.operatorPhone,
                enterpriseName: this.enterpriseName,
                enterpriseCreditCode: this.enterpriseCreditCode,
                legalRepName: this.legalRepName
            }).then((res) => {
                this.$TsaLoading.hide()
                if (res.code == '0') {
                    this.show = true
                    this.pdfUrl = res.data.pdfUrl
                    this.ossKey = res.data.ossKey
                    // console.error(this.pdfUrl)
                }
            }).catch(() => {
                this.$TsaLoading.hide()
            })
        },
        close () {
            this.show = false
        },
        confirm () {
            if (!this.checked) {
                this.$toast('请先阅读并同意《机构委托授权书》')
                return
            }
            this.show = false
            this.onConfirm && this.onConfirm({
                ossKey: this.ossKey
            })
        },
        checkedFun () {
            this.checked = !this.checked
        },
        preview () {
            this.$TsaAgreement.show({
                title: '机构委托授权书',
                url: this.pdfUrl,
                onConfirm: async () => {
                    this.$TsaAgreement.hide()
                    this.checked = true
                },
                onCancel: () => {
                    this.$TsaAgreement.hide()
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-authorizationLetter {
        position: fixed;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        * {
            box-sizing: border-box;
        }
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.65);
        }
        .content {
            display: flex;
            flex-direction: column;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            max-height: 95%;
            border-radius: 8px;
            background: #FFFFFF;
            border-radius: 16px 16px 0px 0px;
            .title-top {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;
                padding: 16px 20px 0 16px;
                h4 {
                   font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }
                img {
                    width: 24px;
                    height: 24px;
                }
            }
            .scroll {
                flex: 1;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                padding: 0 16px;
                margin-bottom: 20px;
                .text-container {
                    width: 100%;
                    background: #F7F9FD;
                    border-radius: 8px;
                    padding: 12px;
                    margin-bottom: 10px;
                    p {
                        font-size: 14px;
                        color: #666666;
                        line-height: 22px;
                        &:first-child {
                            margin-bottom: 10px;
                        }
                    }
                }
                .checked {
                    display: flex;
                    align-items: center;
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 8px;
                    }
                    p {
                        font-size: 14px;
                        color: #666666;
                        span {
                            color: #0047FF;
                        }
                    }
                }
            }
            
            .bottom {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                padding: 16px;
                box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
                .btn {
                    flex: 1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 162px;
                    height: 44px;
                    border-radius: 8px;
                    border: 1px solid #D9D9D9;
                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .confirm {
                    margin-left: 12px;
                    background: linear-gradient( 90deg, #0047FF 0%, #2377FF 100%);
                    p {
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/authorizationLetter/index.vue